export default __webpack_public_path__ + "static/article-finance-why-generation-y-e024b2e6219bfdaf25704a031f4a44b7.jpg";